export default __webpack_public_path__ + "static/media/yellow_pawn.c51f88be.png";